(() => {
  const FORM_SELECTOR = '.header__search-form';
  const INPUT_SELECTOR = 'input[type="search"]';
  const RESULTS_SELECTOR = '[data-predictive-search]';
  const OPEN_CLASS = 'predictive-search--open';

  const debounce = (fn, delay = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const fetchResults = async (term, signal) => {
    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product,collection,page,article',
      'resources[limit]': '8',
      section_id: 'predictive-search'
    });
    const searchUrl = window.routes?.predictive_search_url || '/search/suggest';

    const res = await fetch(`${searchUrl}?${params.toString()}`, {
      headers: { Accept: 'text/html' },
      signal
    });

    if (!res.ok) throw new Error(`Predictive search failed: ${res.status}`);
    return res.text();
  };

  const init = () => {
    document.querySelectorAll(FORM_SELECTOR).forEach(form => {
      const input = form.querySelector(INPUT_SELECTOR);
      const resultsEl = form.querySelector(RESULTS_SELECTOR);
      if (!input || !resultsEl) return;

      let controller;
      resultsEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');

      const close = () => {
        controller?.abort();
        resultsEl.classList.remove(OPEN_CLASS);
        resultsEl.innerHTML = '';
        resultsEl.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const openWithHtml = html => {
        resultsEl.innerHTML = html;
        resultsEl.hidden = false;
        resultsEl.classList.add(OPEN_CLASS);
        input.setAttribute('aria-expanded', 'true');
      };

      const onInput = debounce(async () => {
        const term = (input.value || '').trim();
        if (term.length < 2) return close();

        controller?.abort();
        controller = new AbortController();

        try {
          const html = await fetchResults(term, controller.signal);
          openWithHtml(html);
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.warn(error);
          close();
        }
      }, 200);

      input.addEventListener('input', onInput);
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') close();
      });
      form.addEventListener('submit', () => controller?.abort());

      document.addEventListener('click', event => {
        if (!form.contains(event.target)) close();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
